module.exports = __webpack_public_path__ + "static/media/faq-screenshot.dfac6972.png";